/**
 * Adobe Fonts (Typekit) value format and parsing.
 *
 * Stored in branding config as: adobe:PROJECT_ID:FONT_ID
 * - PROJECT_ID: Adobe Fonts / Typekit project ID (e.g. from use.typekit.net/XXXXX.js)
 * - FONT_ID: Font family name to use in CSS (e.g. "source-sans-pro")
 */

export const ADOBE_FONT_PREFIX = "adobe:";

export function isAdobeFontSpec(spec: string): boolean {
  return spec.startsWith(ADOBE_FONT_PREFIX);
}

export function parseAdobeFontSpec(spec: string): {
  projectId: string;
  fontId: string;
} | null {
  if (!isAdobeFontSpec(spec)) return null;
  const rest = spec.slice(ADOBE_FONT_PREFIX.length);
  const colonIndex = rest.indexOf(":");
  if (colonIndex === -1) return null;
  const projectId = rest.slice(0, colonIndex).trim();
  const fontId = rest.slice(colonIndex + 1).trim();
  if (!projectId || !fontId) return null;
  return { projectId, fontId };
}

export function formatAdobeFontValue(
  projectId: string,
  fontId: string
): string {
  return `${ADOBE_FONT_PREFIX}${projectId.trim()}:${fontId.trim()}`;
}

/**
 * Returns the CSS font-family value for an Adobe font spec.
 * Used by theme and BrandedChakraProvider.
 */
export function getAdobeFontFamilyName(spec: string): string | null {
  const parsed = parseAdobeFontSpec(spec);
  return parsed?.fontId ?? null;
}
